var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#08878F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 22.5C13.1389 22.5 13.5347 22.3443 13.8542 22.0328C14.1736 21.7214 14.3333 21.3354 14.3333 20.875V11.125C14.3333 10.6646 14.1736 10.2786 13.8542 9.96719C13.5347 9.65573 13.1389 9.5 12.6667 9.5C12.1944 9.5 11.7986 9.65573 11.4792 9.96719C11.1597 10.2786 11 10.6646 11 11.125V20.875C11 21.3354 11.1597 21.7214 11.4792 22.0328C11.7986 22.3443 12.1944 22.5 12.6667 22.5ZM19.3333 22.5C19.8056 22.5 20.2014 22.3443 20.5208 22.0328C20.8403 21.7214 21 21.3354 21 20.875V11.125C21 10.6646 20.8403 10.2786 20.5208 9.96719C20.2014 9.65573 19.8056 9.5 19.3333 9.5C18.8611 9.5 18.4653 9.65573 18.1458 9.96719C17.8264 10.2786 17.6667 10.6646 17.6667 11.125V20.875C17.6667 21.3354 17.8264 21.7214 18.1458 22.0328C18.4653 22.3443 18.8611 22.5 19.3333 22.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopTimer);
export default __webpack_public_path__ + "static/media/stop_timer.442b659af9da2b6d09f8054c20be9248.svg";
export { ForwardRef as ReactComponent };